import { render, staticRenderFns } from "./BotaoGestaoOperacoes.vue?vue&type=template&id=0c778d06&lang=pug"
import script from "./BotaoGestaoOperacoes.vue?vue&type=script&lang=js"
export * from "./BotaoGestaoOperacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports